import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";

import { track, ANALYTICS_ACTIONS } from "~/core/analytics";
import { FONTS } from "~/themes/typography";
import { Grid } from "~/components/grid";
import { HeadlineBlock } from "~/components/headline-block";
import { Body, SmallHeadline } from "~/components/typography";
import { Button, BUTTON_VARIANTS } from "~/components/button";

import { PdpWrapper } from "./../pdp.style";
import {
  OpenCardWrapper,
  MessageHeadline,
  MessageWrapper,
  MessageSide,
  MessagePlaceholder,
  MessageOptions,
  MessageOption,
  MessageOptionScroll,
  MessageControls,
} from "./message.style";

const placeholder = `Hello Friend,
Thank you for everything!
Best
`;

export const PdpMessage = ({
  font,
  setFont,
  message,
  setMessage,
  quantity,
  onNext,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const label = message
    ? `Add ${quantity > 1 ? `${quantity} ` : ''}Card${quantity > 1 ? 's' : ''}`
    : `Add ${quantity > 1 ? `${quantity} ` : ''}Blank${quantity > 1 ? 's' : ''}`;
  const onFocus = () => setIsFocused(true);
  const onBlur = () => setIsFocused(Boolean(message));
  const onChange = ({ target }) => {
    const cleanText = target.value
      .replace(/[^a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?\s]/ig, "");
    setMessage(cleanText);
  }

  const onBuy = () => {
    onNext();
    track.click({
      action: ANALYTICS_ACTIONS.ADD_TO_CART,
      label,
    });
  }

  useEffect(() => {
    if (!message) {
      setIsFocused(false);
    }
  }, [message]);

  const options = useMemo(() => {
    return FONTS
      .map(({ value, label }) => {
        const onPointerUp = () => {
          setFont(value);
          track.click({
            action: ANALYTICS_ACTIONS.CHANGE_FONT,
            label,
            value,
          });
        }
        return (
          <MessageOption
            key={value}
            onPointerUp={onPointerUp}
            $isActive={font === value}
            $font={value}
          >
            {label}
          </MessageOption>
        );
      });
  }, [font, setFont]);

  return (
    <PdpWrapper id="message">
      <MessageHeadline>
        <HeadlineBlock
          value="Personalize"
          color="accentTwo"
        >
          <Body color="primary">
            Craft your own personalized message and we'll print, stamp, and have the cards delivered for you.
          </Body>
        </HeadlineBlock>
      </MessageHeadline>
      <Grid>
        <MessageWrapper>
          <OpenCardWrapper>
            <MessageSide />
            <MessageSide
              $font={font}
            >
              {!isFocused && (
                <MessagePlaceholder>
                  {placeholder}
                </MessagePlaceholder>
              )}
              <textarea
                value={message}
                maxLength={500}
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onBlur}
              />
            </MessageSide>
          </OpenCardWrapper>

          <MessageOptions>
            <SmallHeadline>Select a font ({FONTS.length})</SmallHeadline>
            <MessageOptionScroll>
              {options}
            </MessageOptionScroll>
            <MessageControls>
              <Button
                label={label}
                variant={BUTTON_VARIANTS.PRIMARY}
                onClick={onBuy}
              />
            </MessageControls>
          </MessageOptions>
        </MessageWrapper>
      </Grid>
    </PdpWrapper>
  )
};
PdpMessage.propTypes = {
  font: PropTypes.string,
  quantity: PropTypes.number,
  message: PropTypes.string,
  setFont: PropTypes.func,
  setQuantity: PropTypes.func,
  setMessage: PropTypes.func,
  onNext: PropTypes.func,
};

